import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import Close from "mdi-material-ui/Close";
import LogoutVariant from "mdi-material-ui/LogoutVariant";

const LogoutModal = (props) => {
  const { open, handleClose, handleLogout } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      scroll="body"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            top: 10,
            right: 10,
            position: "absolute",
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LogoutVariant
            sx={{ fontSize: "1.375rem", color: "text.secondary", width: "2.5rem", height: "2.5rem" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            py: 3,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="span"
            variant="body3"
            sx={{
              color: theme.palette.secondary.dark,
              fontWeight: 600,
              fontSize: "1.3rem !important",
            }}
          >
            Are you sure want to Logout ?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        className="dialog-actions-dense"
        sx={{
          "&.MuiDialogActions-root": {
            alignItems: "center",
            justifyContent: "space-around",
            mb: 2,
            mx: 20,
          },
        }}
      >
        <Button
          type="reset"
          variant="contained"
          size="medium"
          onClick={handleClose}
          style={{ backgroundColor: theme.palette.text.disabled }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="medium"
          style={{ backgroundColor: theme.palette.error.main }}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LogoutModal.defaultProps = {
  open: false,
  handleClose: () => {},
  handleDelete: () => {},
};

export default LogoutModal;
